import { Button } from 'shared';
import styled from 'theme';

export const SubmitButton = styled(Button)`
  margin-top: 1rem;
`;
